/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_NameInputs */

const en_agent_authorization_field_name = /** @type {(inputs: Agent_Authorization_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project name`)
};

const zh_agent_authorization_field_name = /** @type {(inputs: Agent_Authorization_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目名称`)
};

/**
* | output |
* | --- |
* | "Project name" |
*
* @param {Agent_Authorization_Field_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_name = /** @type {((inputs?: Agent_Authorization_Field_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_name(inputs)
	return zh_agent_authorization_field_name(inputs)
});
export { agent_authorization_field_name as "agent.authorization.field.name" }